export default "__VITE_ASSET__CamZwzCU__"